/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-10 13:57:07 */

const Keys = {
  oldPassword: 'oldPassword',
  password: 'password',
  passwordConfirmation: 'passwordConfirmation',
  requiredField: 'requiredField',
  passwordsMustMatch: 'passwordsMustMatch',
  submit: 'submit'
}; export default Keys;